export const BoardAiReducer = (
  state = {
    TaskSuggests: [],
  },
  action
) => {
  switch (action.type) {
    case "GET_TASK_SUGGESTS": {
      return {
        ...state,
        TaskSuggests: action.Payload,
      };
    }

    default: {
      return state;
    }
  }
};
